import { ActionCreators as UndoActionCreators } from "redux-undo";
import { actions } from "store/actions";
import { selectors } from "store/selectors";
import { isCentralizedSystem } from "store/system-data/helpers";
import { NodeComponentType } from "store/types";
var isCentralized = function (state) {
    return isCentralizedSystem(state.systemDataDefineParameters.dataState.data);
};
/*
 * Switching between a central and a decentral system changes how pumps and
 * cups connect, so what was built for the old type no longer fits: the tubes
 * go, with the results and overlay computed for them, and the undo history
 * (with its selection snapshots) is cleared so an undo cannot bring back
 * nodes that are incompatible with Tacton's new state. Nothing happens while
 * the type is first loaded.
 *
 * A decentral system hides its central pumps rather than deleting them, so
 * they are dropped from the selection too: otherwise the sidebar keeps the
 * hidden pump's menu open, offering the decentral pumps for a central pump
 * slot, which Tacton rejects ("Value not in domain").
 */
export var generateListeners = function (startAppListening) { return [
    function () {
        return startAppListening({
            predicate: function (_, currentState, previousState) {
                var previous = isCentralized(previousState);
                return (previous !== undefined && previous !== isCentralized(currentState));
            },
            effect: function (_, _a) {
                var dispatch = _a.dispatch, getState = _a.getState;
                var state = getState();
                if (!isCentralized(state)) {
                    var selectedIds = selectors.selectSelectedIds(state);
                    var nodes_1 = state.scene.present.nodes;
                    var visibleIds = selectedIds.filter(function (id) { var _a; return ((_a = nodes_1[id]) === null || _a === void 0 ? void 0 : _a.type) !== NodeComponentType.CENTRALIZED_VACUUM_PUMP; });
                    if (visibleIds.length === 0 && selectedIds.length > 0) {
                        dispatch(actions.deselectEntities());
                    }
                    else if (visibleIds.length < selectedIds.length) {
                        dispatch(actions.selectEntities(visibleIds));
                    }
                }
                dispatch(actions.deleteAllEdges());
                dispatch(actions.clearPerformanceData());
                dispatch(actions.setOverlayData(undefined));
                dispatch(UndoActionCreators.clearHistory());
                dispatch(actions.clearSnapshots());
            },
        });
    },
]; };
